import React from "react";
import TenantServicesTab from "../TenantServicesTab";

const OnboardingStepServices = ({ tenantId, services, onToggleService, disabled }) => (
  <div className="space-y-4">
    <p className="text-sm text-slate-500">
      Enable or disable AI services for this tenant. At least one service must be enabled before activation.
    </p>
    <TenantServicesTab
      tenantId={tenantId}
      services={services}
      onToggleService={onToggleService}
      disabled={disabled}
    />
  </div>
);

export default OnboardingStepServices;
